<template>
  <el-card class="h-full">
    <div class="w-full h-full">
      <div class="flex justify-between items-center">
        <div class="title text-lg mb-10px cursor-pointer">
          <el-page-header
            v-if="pageType === 'read'"
            @back="$emit('cancel')"
            content="详情"
          ></el-page-header>
          <span
            v-if="pageType !== 'read'"
            class="border-l-3 border-color-primary pl-10px text-18px"
            >{{ pageType === 'create' ? '新增' : '编辑' }}</span
          >
        </div>
      </div>
      <div
        v-loading="pageLoading"
        class="w-full overflow-y-auto overflow-x-hidden"
        :class="[pageType === 'read' ? 'detail-height' : 'custom-height']"
      >
        <el-form ref="form" label-width="140px" :rules="rules" :model="formData">
          <el-collapse v-model="collapseActiveName">
            <el-collapse-item title="考试基本信息" name="baseInfo">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item
                    label="考试名称"
                    prop="name"
                    :rules="[
                      {
                        required: true,
                        message: `请输入考试名称`,
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="formData.name"
                      placeholder="请输入考试名称"
                      maxlength="20"
                      show-word-limit
                      clearable
                      :disabled="['read'].includes(pageType)"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item
                    label="考试编码"
                    prop="no"
                    :rules="[
                      {
                        required: true,
                        message: `请输入考试编码`,
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="formData.no"
                      placeholder="请输入考试编码"
                      maxlength="20"
                      show-word-limit
                      clearable
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item
                    label="考试类型"
                    prop="type"
                    :rules="[
                      {
                        required: true,
                        message: `请选择考试类型`,
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-select
                      v-model="formData.type"
                      class="w-full"
                      size="small"
                      placeholder="请选择考试类型"
                      :disabled="['read'].includes(pageType)"
                    >
                      <el-option
                        v-for="item in riskJobTypeList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item
                    label="考试时间"
                    prop="datePickerValue"
                    :rules="[
                      {
                        required: true,
                        message: `请选择考试时间`,
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-date-picker
                      v-model="formData.datePickerValue"
                      format="yyyy-MM-dd HH:mm:ss"
                      size="small"
                      type="datetimerange"
                      :clearable="true"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :disabled="['read'].includes(pageType)"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item
                    label="考试总分"
                    prop="score"
                    :rules="[
                      {
                        required: true,
                        message: `请输入考试总分`,
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-input-number
                      v-model="formData.score"
                      placeholder="请输入考试总分"
                      class="w-full"
                      :min="0"
                      :precision="0"
                      maxlength="20"
                      show-word-limit
                      clearable
                      :disabled="['read'].includes(pageType)"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item
                    label="积分"
                    prop="integral"
                    :rules="[
                      {
                        required: true,
                        message: `请输入积分`,
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-input-number
                      v-model="formData.integral"
                      placeholder="请输入积分"
                      class="w-full"
                      :min="0"
                      :precision="0"
                      maxlength="20"
                      show-word-limit
                      clearable
                      :disabled="['read'].includes(pageType)"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item name="taskAssign" title="考试场次">
              <el-row>
                <el-col :span="24">
                  <el-button type="primary" class="mb-10px">添加</el-button>
                </el-col>
                <el-col :span="24">
                  <el-table
                    :data="sourcesDangerRecognitionPlanTaskDtos"
                    border
                    class="w-full mb-20px"
                    stripe
                    :height="tableHeight"
                    row-key="id"
                    default-expand-all
                    v-loading="tableLoading"
                    :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                  >
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column label="题目名称" prop="name">
                      <template slot-scope="scope">
                        <span v-if="scope.row.level"
                          >{{ scope.row.name }}，共（{{
                            scope.row && scope.row.children.length
                          }}）题，共计（{{ questionScore(scope.row.children) }}）分</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column label="分值" width="200" prop="score">
                      <template slot-scope="scope">
                        <span v-if="scope.row.level">{{ questionScore(scope.row.children) }}</span>
                        <el-input-number
                          v-else
                          v-model="scope.row.score"
                          placeholder="请输入建议答题时长"
                          class="w-full"
                          :min="1"
                          :precision="0"
                          maxlength="20"
                          show-word-limit
                          clearable
                          :disabled="['read'].includes(pageType)"
                        ></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="220">
                      <template slot-scope="scope">
                        <el-button
                          :disabled="['read'].includes(pageType)"
                          size="mini"
                          v-if="!scope.row.level"
                          @click="
                            handleFormEvent(
                              scope.row,
                              scope.row.type,
                              scope.row.parentIndex,
                              'delete'
                            )
                          "
                          >移除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </div>
      <div class="w-full flex justify-center items-center mt-5 mb-5" v-if="pageType !== 'read'">
        <el-button
          type="primary"
          size="small"
          @click="submitForm('submit')"
          :loading="saveLoading"
          :disabled="pageLoading"
          >保存</el-button
        >
        <el-button @click="$emit('cancel')" size="small">取消</el-button>
      </div>

      <!-- 选择试卷start -->
      <choose-exam-form
        v-if="pointDialog"
        :taskIds="taskIds"
        pageOrigin="exam"
        :filterField="curExamType"
        :pointProps="pointProps"
        @add-type-question="addRiskPoint"
        @cancel="pointDialog = false"
      >
      </choose-exam-form>
      <!-- 选择试卷end -->

      <!-- 添加人员start -->
      <AddUser
        :visible.sync="addUserDialog"
        :disabled="pageType === 'read'"
        title="发起人"
        :treeData="treeData"
        treeNodeKey="id"
        :filterRepeat="true"
        repeatKey="id"
        :treeLoading="treeLoading"
        treeCheckField="isActive"
        :treeCkeckValue="true"
        :treeProps="{
          children: 'childen',
          label: 'name',
        }"
        :defaultSelectKeys="defaultSelectKeys"
        @save="saveData"
      ></AddUser>
      <!-- 添加人员end -->
    </div>
  </el-card>
</template>

<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { QuestionBankApi, QuestionSourceApi } from '@wiz-api/exam-management'
import utils from '@/components/safety/enumField/utils'
import { AddUser } from '@wiz-core/compts'
import ChooseExamForm from './ChooseExamForm'

const questionBankApi = new QuestionBankApi()
const questionSourceApi = new QuestionSourceApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  name: 'paper-form',
  components: {
    AddUser,
    ChooseExamForm,
  },
  data() {
    return {
      // 人员选中names集合
      assessmentUserNamesStr: '',
      // 选中的人员ids集合
      defaultSelectKeys: [],
      // 添加人员的弹窗
      addUserDialog: false,
      // 人员树形数据
      treeData: [],
      // tree加载节点
      treeLoading: false,
      pageType: 'create',
      rowId: null,
      tableLoading: false,
      // 关联题源
      sourcesDangerRecognitionPlanTaskDtos: [],
      pageLoading: false,
      riskJobTypeList: [
        {
          code: '0',
          displayName: '三级安全教育',
        },
        {
          code: '1',
          displayName: '电力基础知识',
        },
        {
          code: '2',
          displayName: '电厂设备与运维',
        },
        {
          code: '3',
          displayName: '安全生产与应急处理',
        },
        {
          code: '4',
          displayName: '环保与节能',
        },
      ],
      collapseActiveName: ['baseInfo', 'taskAssign'],
      selectionData: [],
      // 风险点
      pointProps: {
        visible: false,
      },
      pointDialog: false,
      saveLoading: false,
      formData: {
        name: '',
        type: undefined,
        serialNumber: '',
        associateRiskyActivityType: undefined,
        singleChoiceQuantity: 0,
        multiSelectQuantity: 0,
        judgeQuantity: 0,
        fillBlankQuantity: 0,
        questionAnswersQuantity: 0,
        questionBankNotes: '',
        bankSourceIds: [],
      },
      rules: {},
    }
  },
  computed: {
    tableHeight() {
      return this.pageType === 'read' ? 'calc(100vh - 400px)' : 'calc(100vh - 450px)'
    },
    // 禁用ids集合
    taskIds() {
      const ids = []
      _.forEach(this.sourcesDangerRecognitionPlanTaskDtos, (item) => {
        if (item.children && item.children.length > 0) {
          _.forEach(item.children, (ele) => {
            ids.push(ele.id)
          })
        }
      })

      // 传入
      return ids
    },
  },
  methods: {
    // 递归，算出总分
    getTotalScore(arr, totalScore = 0) {
      _.forEach(arr, (item) => {
        totalScore = totalScore + Number(item.score)
        if (item.children && item.children.length > 0) {
          _.forEach(item.children, (ele) => {
            totalScore = totalScore + Number(ele.score)
          })
        }
      })
      return totalScore
    },
    // 获取详情
    async getDetail() {
      this.pageLoading = true
      const [err, res] = await questionBankApi.get(this.rowId)
      if (!err) {
        this.formData = { ...res }
        if (!this.formData.bankSourceIds || this.formData.bankSourceIds.length === 0) {
          this.formData.bankSourceIds = []
        } else {
          this.getChooseQestionList()
        }
      }
      this.pageLoading = false
    },
    // 获取选中的题源内容
    async getChooseQestionList() {
      this.tableLoading = true
      const [err, res] = await questionSourceApi.pagedListQuery({
        skipCount: 0,
        maxResultCount: 999,
        bankSourceIds: this.formData.bankSourceIds,
      })
      if (!err) {
        this.sourcesDangerRecognitionPlanTaskDtos = res.items
      }
      this.tableLoading = false
    },
    // 添加风险测点
    addRiskPoint(data) {
      this.sourcesDangerRecognitionPlanTaskDtos = [
        ...data,
        ...this.sourcesDangerRecognitionPlanTaskDtos,
      ]
      this.pointProps.visible = false
      this.pointDialog = false
    },
    // 保存的数据
    saveData(data) {
      this.assessmentUserNamesStr = _.map(data, (item) => {
        return item.name
      }).join(',')
      this.defaultSelectKeys = _.map(data, (item) => {
        return item.organizationUnitId + item.id
      })
      this.formData.assessmentUserIds =
        data && data.length > 0
          ? _.map(data, (item) => {
            return item.id
          }).join(',')
          : undefined
    },
    /**
     * 列表操作-事件
     * @param {*} row 行数据
     * @param {*} examType 题目类型 单选，多选，判断，填空以及简答题, 默认单选题
     * @param {*} parentIndex 操作索引
     * @param {*} operation 操作类型
     */
    handleFormEvent(row, examType, parentIndex, operation) {
      let questionIndex = 0
      let childrenArr = []
      switch (operation) {
        // 删除
        case 'delete':
          this.$confirm('是否移除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              questionIndex = this.sourcesDangerRecognitionPlanTaskDtos.findIndex((item) => {
                return item.type === examType
              })
              childrenArr = this.sourcesDangerRecognitionPlanTaskDtos[questionIndex].children
              childrenArr.splice(parentIndex, 1)
              this.$nextTick(() => {})
            })
            .catch(() => {})
          this.addListIndex()
          break
        // 添加场次
        case 'chooseRiskPoint':
          this.pointProps.visible = true
          this.pointDialog = true
          break
        default:
          break
      }
    },
    /**
     * 表单提交
     */
    async submitForm() {
      let err = null
      let res = null
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.formData.id) {
            // 编辑
            ;[err, res] = await questionBankApi.update(this.formData.id, {
              body: this.formData,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
              this.$emit('refreshList')
            }
          } else {
            // 新增
            ;[err, res] = await questionBankApi.create({
              body: this.formData,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
              this.$emit('refreshList')
            }
          }
        }
      })
    },
    /**
     * @description 获取组织机构和人员
     */
    async getUserTree() {
      this.treeLoading = true
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserTree({
        outputPost: true,
      })
      if (!err) {
        this.treeData = res
        this.dealUserTree(this.treeData)
      }
      this.treeLoading = false
    },
    /**
     * @description 目录树子节点数据调整
     * @param {Array} treeData
     */
    dealUserTree(treeData) {
      _.forEach(treeData, (treeItem) => {
        if (treeItem.childen) {
          treeItem.keyId = treeItem.organizationUnitId
          treeItem.name = treeItem.organizationUnitName
          if (treeItem.userList) {
            _.forEach(treeItem.userList, (userItem) => {
              userItem.keyId = treeItem.organizationUnitId + userItem.id
              userItem.organizationUnitId = treeItem.organizationUnitId
              userItem.organizationUnitName = treeItem.organizationUnitName
            })
            treeItem.childen.push(...treeItem.userList)
          }
          this.dealUserTree(treeItem.childen)
        }
      })
    },
  },
  mounted() {
    if (!_.isEmpty(this.$route.query)) {
      this.pageType = this.$route.query.pageType
      this.rowId = this.$route.query.rowId
    }
    // utils.getDataCategory(['ExamManagement.DataCategory.RiskJobType'], ['riskJobTypeList'], this)
    if (this.pageType !== 'create') {
      this.getDetail()
    }
    // 添加orderIndex显示排序操作和进行排序
    this.addListIndex()
    // 获取用户树结构
    this.getUserTree()
  },
}
</script>

<style scoped lang="scss">
.form-nolabel {
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    margin-top: 20px !important;
  }
}

.custom-height {
  height: calc(100% - 95px);
}

.detail-height {
  height: calc(100% - 50px);
}
</style>
